import type { CryptoCurrencyDataSource, FiatCurrency } from '@0xtorch/core'
import {
  type AccountingPeriod,
  selectAssetBalances,
  selectAssetBorrows,
  selectCryptoCurrencies,
  upsertAssetValues,
} from '@pkg/database-portfolio'
import type { RunToDatabase } from '../types'
import { generateAssetValues } from './generateAssetValues'

type SaveAssetValuesParameters = {
  readFromDatabase: RunToDatabase
  writeToDatabase: RunToDatabase
  accountingPeriod: AccountingPeriod
  cryptoCurrencyDataSource: CryptoCurrencyDataSource
  fiat: FiatCurrency
}

export const saveAssetValues = async ({
  readFromDatabase,
  writeToDatabase,
  accountingPeriod,
  cryptoCurrencyDataSource,
  fiat,
}: SaveAssetValuesParameters) => {
  const assetBalances = await readFromDatabase((database) =>
    selectAssetBalances({ database, accountingPeriodId: accountingPeriod.id }),
  )
  const assetBorrows = await readFromDatabase((database) =>
    selectAssetBorrows({ database, accountingPeriodId: accountingPeriod.id }),
  )
  const cryptoCurrencies = await readFromDatabase((database) =>
    selectCryptoCurrencies({ database }),
  )

  const assetValues = await generateAssetValues({
    cryptoCurrencyDataSource,
    accountingPeriod,
    assetBalances,
    assetBorrows,
    cryptoCurrencies,
    fiat,
  })

  // asset value data を保存
  await writeToDatabase((database) =>
    upsertAssetValues({
      database,
      accountingPeriodId: accountingPeriod.id,
      data: assetValues,
    }),
  )
}
